import { useCallback } from 'react';
import { ACTION } from '../tools/constants';

/**
 * Dispatch a custom event to update the URL with the new categoryId.
 *
 * @param {function} dispatch - The useReducer dispatch function to update state.
 * @param {string} pagefm - The pagefm parameter to include in the state update.

 */
const useHandleNavClick = (
  dispatch,
  pagefm,
) => useCallback((event) => {
  const url = event?.currentTarget?.href || event?.detail?.url;
  const { categoryId, categoryName } = event?.currentTarget?.dataset || event?.detail;

  dispatch({
    type: ACTION.CATEGORY_CHANGE,
    payload: {
      categoryId,
      categoryName,
      pagefm,
      url,
    },
  });
}, [dispatch, pagefm]);

export default useHandleNavClick;
